module.exports = __webpack_public_path__ + "img/bow_length.626984eb.png";